import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Firebase } from '../../firebase/firebase.class';

interface ClientsState {
  readonly firebase: Firebase | null;
  readonly firebaseLoggedIn: boolean;
  readonly firebaseScaffolded: boolean;
}

const initialState: ClientsState = {
  firebase: null,
  firebaseLoggedIn: false,
  firebaseScaffolded: false,
};

const clientsSlice = createSlice({
  initialState,
  name: 'clients',
  reducers: {
    setFirebaseInstance: (state, action: PayloadAction<Firebase>) => {
      state.firebase = action.payload;
    },
    setFirebaseLoggedInState: (state, action: PayloadAction<boolean>) => {
      state.firebaseLoggedIn = action.payload;
    },
    setFirebaseScaffolded: (state, action: PayloadAction<boolean>) => {
      state.firebaseScaffolded = action.payload;
    },
  },
});

export const {
  setFirebaseInstance, setFirebaseLoggedInState, setFirebaseScaffolded,
} = clientsSlice.actions;

export default clientsSlice.reducer;
